import 'regenerator-runtime/runtime';
import { takeEvery, takeLatest, call, put, fork } from 'redux-saga/effects';

import api from 'api';

import { FETCH_AVAILABLE_YEARS_REQUEST, FETCH_INFO_REQUEST } from './actionTypes';

import {
  fetchAvailableYearsSuccess,
  fetchAvailableYearsFailure,
  fetchInfoSuccess,
  fetchInfoFailure,
} from './actionCreators';

function* fetchAvailableYearsSaga() {
  try {
    const years = yield call(api.fetchDac7AvailableYears);
    yield put(fetchAvailableYearsSuccess(years));
  } catch (error) {
    yield put(fetchAvailableYearsFailure(error));
  }
}

function* fetchInfoSaga(action) {
  const { year } = action.payload;
  try {
    const info = yield call(api.fetchDac7Info, year);
    yield put(fetchInfoSuccess(year, info));
  } catch (error) {
    yield put(fetchInfoFailure(year, error));
  }
}

export default [
  fork(takeLatest, FETCH_AVAILABLE_YEARS_REQUEST, fetchAvailableYearsSaga),
  fork(takeEvery, FETCH_INFO_REQUEST, fetchInfoSaga),
];
